import React from 'react';
import './SpecialOffers.css'; 


const SpecialOffers = () => {
  return (


<div className='container-fluid'>
  <div className="special-offer-section text-white text-center d-flex flex-column justify-content-center align-items-center" data-sal='fade' data-sal-duration="2000" data-sal-delay="300" style={{ width: "100%" }}>
    <h1 className="display-4 fw-bold text-war mb-3" style={{ textTransform: "uppercase" }} data-sal='slide-down' data-sal-duration="2000" data-sal-delay="300">Special Offers</h1>
    <p className="lead p-lead px-3 px-md-5" data-sal='slide-right' data-sal-duration="2000" data-sal-delay="300">
      Take advantage of our limited-time promotions! Get a free consultation and <span className="text-war fw-bold">10% off</span> your first
      renovation project with Velar Heights Renovation.
    </p>
    <a href="/kitchen-renovations">
    <button className=" btn-war btn-lg mt-4" data-sal='fade' data-sal-duration="2000" data-sal-delay="300">
      Take Advantage of Our Offers <span>&#8594;</span>
    </button>
    </a>
  </div>
</div>


  );
};

export default SpecialOffers;
